// ตัวเลือกโมเดล (แถบบนหน้าแชท) — โมเดลในเครื่องใช้ได้ทันที / โมเดลคลาวด์แสดง "เร็วๆ นี้"
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isUsable, fmtMB } from "../../services/ai/models";
import { Badge, Icon, ModelMark } from "../ui";

export default function ModelPicker({ value, onChange }) {
  const { models } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const cur = models.find((m) => m.id === value) || models[0];
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  const local = models.filter((m) => m.kind === "local");
  const cloud = models.filter((m) => m.kind !== "local");
  const Row = ({ m }) => {
    const usable = isUsable(m);
    return (
      <button
        type="button"
        className={"mp-row" + (m.id === value ? " is-active" : "") + (usable ? "" : " is-locked")}
        onClick={() => {
          if (!usable) return;
          onChange(m.id);
          setOpen(false);
        }}
      >
        <ModelMark model={m} size={30} />
        <span className="mp-info">
          <span className="mp-name">
            {m.name}
            {m.id === value ? <Icon name="check" size={15} className="brand" /> : null}
          </span>
          <span className="mp-desc">{m.desc}</span>
        </span>
        <span className="mp-meta">
          {usable ? <span className="mp-rate">×{m.rate}</span> : <Badge tone="soft" icon="lock">เร็วๆ นี้</Badge>}
          {usable && m.downloadMB ? <span className="faint tiny">{fmtMB(m.downloadMB)}</span> : null}
        </span>
      </button>
    );
  };
  return (
    <div className="mp" ref={ref}>
      <button type="button" className="mp-trigger" onClick={() => setOpen((o) => !o)}>
        <ModelMark model={cur} size={24} />
        <span className="mp-trigger-name">{cur?.name}</span>
        <Icon name="down" size={16} />
      </button>
      {open ? (
        <div className="mp-pop">
          <div className="mp-section">
            <span>รันในเครื่องคุณ</span>
            <Badge tone="success" icon="shield">ข้อมูลไม่ออกนอกเครื่อง</Badge>
          </div>
          {local.map((m) => <Row key={m.id} m={m} />)}
          <div className="mp-section">
            <span>โมเดลคลาวด์ชั้นนำ</span>
            <Badge tone="soft">กำลังเปิดให้บริการ</Badge>
          </div>
          {cloud.map((m) => <Row key={m.id} m={m} />)}
          <Link to="/models" className="mp-all" onClick={() => setOpen(false)}>
            ดูรายละเอียดโมเดลทั้งหมด <Icon name="arrowRight" size={15} />
          </Link>
        </div>
      ) : null}
    </div>
  );
}
